// --- src/components/UI/Toast.js ---
import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const Icon = type === 'success' ? CheckCircle : type === 'error' ? AlertCircle : Info;
  const color = type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#007bff';

  return (
    <div className={`toast ${type}`}>
      <Icon size={20} color={color} style={{ flexShrink: 0 }} />
      <div className="toast-content">
        <div className="toast-title" style={{ color }}>{type.charAt(0).toUpperCase() + type.slice(1)}</div>
        <div className="toast-message">{message}</div>
      </div>
      <button onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#999' }}>
        <X size={16} />
      </button>
    </div>
  );
};
export default Toast;